var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.89 82.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #039;\n      }\n\n      .cls-2 {\n        fill: #b6c4d8;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: #e4ebf4;\n      }\n\n      .cls-4 {\n        stroke: #3a4561;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .cls-7 {\n        fill: #e0e8f6;\n      }\n\n      .cls-8 {\n        fill: #204cba;\n        mix-blend-mode: multiply;\n        opacity: .2;\n      }\n\n      .cls-9 {\n        fill: #00cc87;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.64,23.06v54.84c0,2.14-1.74,3.88-3.88,3.88H20.81c-2.14,0-3.88-1.74-3.88-3.88V4.13c0-2.14,1.73-3.88,3.88-3.88h34.02l22.77,22.77.04.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.64 22.14 77.6 39.73 77.6 23.02 56.64 22.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.83.25l22.77,22.77h-18.29c-2.47,0-4.48-2.01-4.48-4.48V.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 28.36,
    y: 55.05,
    width: 37.86,
    height: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 28.36,
    y: 62.84,
    width: 20.33,
    height: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 28.36,
    y: 47.25,
    width: 37.86,
    height: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 28.36,
    y: 39.45,
    width: 37.86,
    height: 3.12
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 27.8,
    y: 30.3,
    width: 33.92,
    height: 4.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33.32,46.68c0,8.67-7.03,15.69-15.69,15.69-.18,0-.36,0-.55-.01v-31.37c.18,0,.36-.01.55-.01,8.67,0,15.69,7.03,15.69,15.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.69,
    cy: 46.68,
    r: 15.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.63,44.34l-2.09-2.09v5.69c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1v-5.69l-2.09,2.09c-.43.43-1.12.43-1.55,0-.43-.43-.43-1.12,0-1.55l3.96-3.96c.43-.43,1.12-.43,1.55,0l3.96,3.96c.43.43.43,1.12,0,1.55-.43.43-1.12.43-1.55,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.29,46.2c-.61,0-1.1.49-1.1,1.1v3.08c0,1.21.98,2.2,2.2,2.2h10.11c1.21,0,2.2-.98,2.2-2.2v-3.08c0-.61-.49-1.1-1.1-1.1s-1.1.49-1.1,1.1v2.53c0,.3-.25.55-.55.55h-9.01c-.3,0-.55-.25-.55-.55v-2.53c0-.61-.49-1.1-1.1-1.1Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.fe8286e272ea26f7de31930c324d1345.svg";
export { ForwardRef as ReactComponent };